import Modal from "react-bootstrap/Modal";
import React, { useState } from "react";
import { Button } from "react-bootstrap";
import { toast } from "react-toastify";
import { apiCallWithoutToken } from "../../services/v2/apiService";
import * as endPoints from "../../constants/v2/endPoints";
import { updateUserDetailsToStorage } from "../../helpers/authHelpers";

const VerifyMLSAccountModal = ({ show, pendingToken, maskedEmail, onSuccess, onClose }) => {
  const [code, setCode] = useState("");
  const [loading, setLoading] = useState(false);

  const handleSubmit = () => {
    if (code.length !== 6) {
      toast.error("Please enter a 6-digit code.");
      return;
    }

    setLoading(true);

    apiCallWithoutToken(endPoints.VERIFY_MLS_LINK, "POST", {
      pendingToken,
      code,
    })
      .then((response) => {
        const result = response?.result;
        if (!result?.user) {
          toast.error("Verification failed. Please try again.");
          setLoading(false);
          return;
        }

        updateUserDetailsToStorage(
          { result: { user: result.user, userSession: result.userSession, refreshToken: result.refreshToken } },
          "saml"
        );

        toast.success("Account linked successfully!");
        onSuccess();
      })
      .catch((err) => {
        const message = err?.response?.data?.message || err?.message || "Verification failed. Please try again.";
        toast.error(message);
        setLoading(false);
      });
  };

  const handleCodeChange = (e) => {
    const value = e.target.value.replace(/\D/g, "").slice(0, 6);
    setCode(value);
  };

  const handleKeyDown = (e) => {
    if (e.key === "Enter" && code.length === 6) {
      handleSubmit();
    }
  };

  return (
    <Modal
      size="md"
      aria-labelledby="verify-mls-link-modal"
      centered
      backdrop="static"
      show={show}
      onHide={onClose}
    >
      <Modal.Body className="pt-32 pb-32">
        <p className="mb-3 f-size-24">
          Verify Your Account
        </p>
        <p className="mb-3">
          We found an existing Gitcha account associated with your email.
          To link your MLS login, enter the 6-digit code we sent to{" "}
          <strong>{maskedEmail}</strong>.
        </p>

        <div className="mb-4">
          <input
            type="text"
            inputMode="numeric"
            autoComplete="one-time-code"
            className="form-control form-control-lg text-center"
            placeholder="000000"
            value={code}
            onChange={handleCodeChange}
            onKeyDown={handleKeyDown}
            maxLength={6}
            style={{ letterSpacing: "8px", fontSize: "24px" }}
            autoFocus
          />
        </div>

        <p className="text-muted" style={{ fontSize: "14px" }}>
          The code expires in 10 minutes. Check your spam folder if you don't see it.
        </p>

        <div className="modal-btn-wrap mt-4">
          <Button
            variant="primary"
            className="btn w-100"
            onClick={handleSubmit}
            disabled={code.length !== 6 || loading}
          >
            {loading ? "Verifying..." : "Verify & Link Account"}
          </Button>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default VerifyMLSAccountModal;
